import { useState } from 'react';
import { HistoryPeriodEnumKeys, PeriodType } from '@libs/types';

export const usePeriodContextState = (): PeriodType => {
  const [period, setPeriod] = useState<HistoryPeriodEnumKeys>(
    HistoryPeriodEnumKeys.ONE_DAY
  );

  return {
    period,
    setPeriod,
  };
};
